import type { Deal, DealLink, DealStatus } from '@psp-aggregator/sdk';

export type DealStatusLabelKey =
  | 'status.dealDraft'
  | 'status.dealInReview'
  | 'status.dealAgreed'
  | 'status.dealDeclined'
  | 'status.dealRevoked'
  | 'status.expired'
  | 'status.dealTerminated'
  | 'status.dealArchived';

export const DEAL_STATUS_I18N_KEY: Record<DealStatus, DealStatusLabelKey> = {
  agreed: 'status.dealAgreed',
  archived: 'status.dealArchived',
  declined: 'status.dealDeclined',
  draft: 'status.dealDraft',
  expired: 'status.expired',
  in_review: 'status.dealInReview',
  revoked: 'status.dealRevoked',
  terminated: 'status.dealTerminated',
};

export const DEAL_STATUS_FILTER_OPTIONS: readonly DealStatus[] = [
  'draft',
  'in_review',
  'agreed',
  'declined',
  'revoked',
  'expired',
  'terminated',
  'archived',
] as const;

export const DEAL_STATUS_BADGE_CLASS: Record<DealStatus, string> = {
  agreed: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400',
  archived: 'bg-muted text-muted-foreground',
  declined: 'bg-red-500/10 text-red-600 dark:text-red-400',
  draft: 'bg-muted text-muted-foreground',
  expired: 'bg-amber-500/10 text-amber-600 dark:text-amber-400',
  in_review: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
  revoked: 'bg-orange-500/10 text-orange-600 dark:text-orange-400',
  terminated: 'bg-red-500/10 text-red-600 dark:text-red-400',
};

export const effectiveDealStatus = (
  deal: Deal | DealLink,
  now: Date = new Date(),
): DealStatus => {
  const status = 'status' in deal ? deal.status : deal.deal_status;

  if (
    'expires_at' in deal &&
    status === 'in_review' &&
    new Date(deal.expires_at).getTime() <= now.getTime()
  ) {
    return 'expired';
  }

  return status;
};
